export default __webpack_public_path__ + "static/media/270.9d3b2a2a.jpg";